import { useEffect, useRef } from 'react';
import BhStat from '.';

export default function BhStatCommonGa4({
    locale,
    project = 'ecoflow',
    appId,
    systemTimestamp,
    textIdA1,
}: {
    locale: string;
    project: string;
    appId: number;
    systemTimestamp: number;
    textIdA1?: string;
}) {
    const onlyOneLeave = useRef<boolean>(true);
    useEffect(() => {
        setTimeout(() => {
            BhStat.init({
                locale,
                appId: appId,
                project,
                systemTimestamp,
                textIdA1,
            });
            window.addEventListener('beforeunload', () => {
                if (onlyOneLeave.current) {
                    BhStat.leavePage();
                    onlyOneLeave.current = false;
                }
            });
            window.addEventListener(
                'pagehide',
                (event) => {
                    if (onlyOneLeave.current) {
                        BhStat.leavePage();
                        onlyOneLeave.current = false;
                    }
                },
                false,
            );

            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'hidden') {
                    if (onlyOneLeave.current) {
                        BhStat.leavePage();
                        onlyOneLeave.current = false;
                    }
                }
            });
        }, 200);
    }, []);

    return null;
}
